/**
 * What the Scheduler says when a tracker's own Flow Optimizer switch holds it
 * (Tres Commas: off by default). "Update now" reads a held Apply with the
 * drawer's applyHeldReason (Tres Commas only).
 * For Media Devoted | Created By Ciro Autiero
 *
 * The backend's reason already reads as a clause ("Tres Commas Flow Optimizer
 * is off (TRES_COMMAS_FLOW_OPTIMIZER_DISABLED)"), so it is quoted after a
 * colon, never inside another pair of brackets.
 */

/** The reason without a closing full stop, so each sentence ends in exactly one. */
function clause(reason: string): string {
  const text = reason.trim();
  return text.endsWith('.') ? text.slice(0, -1) : text;
}

/** Sentence appended to a confirm while the tracker is held; '' when it is not. */
export function heldNote(reason: string | null): string {
  return reason ? ` Right now it is held: ${clause(reason)}. Nothing runs until that is lifted.` : '';
}

/** The one line of the amber Scheduler notice. */
export function heldLine(label: string): string {
  return `${label} Flow Optimizer is held — nothing is pushed to ${label}.`;
}

/**
 * Behind the notice's help icon: the backend's reason, then what still works
 * (two lines — the hint renders with whitespace-pre-line).
 */
export function heldHint(reason: string): string {
  return `${clause(reason)}.\nConfigs, previews and formulas still work. Pushes start once it is switched on.`;
}
